import CityPageTemplate from "../city-template/CityPageTemplate";
import { havreConfig } from "./data";

export default function HavrePage() {
  return <CityPageTemplate config={havreConfig} />;
}